import { Controller } from "stimulus"
import ga from "../utils/ga"

export default class extends Controller {
  connect() {
    // When there is a redirect, Turbo loads the DOM, a Stimulus connection function is
    // called after a DOM update, but before Turbo updates the document.URL is updated.
    // To ensure we are using the final URL, we start queueing GA events on a Turbo navigation,
    // and we pass a function argument to our `ga` wrapper, which will only set the location when the queue is processed.
    ga(() => ["set", "location", document.URL])
    ga("set", "dimension20", document.body.dataset.pageType)
  }
}
